<app-pageheader [Parent]="this">
  @if (ShowUpload) {
    <button type="button" class="button is-primary is-outlined ml-2 import-from-library-button" [disabled]="Processing" (click)="OpenUpload()">
      <span class="icon-text">
        <span>Upload DMV Data (.csv)</span>
        <span class="icon">
          <i class="fa fa-download"></i>
        </span>
      </span>
    </button>
  }
  @if (ShowDmvActions) {
    <button class="button is-primary ml-2" [disabled]="!CanProcess" (click)="ProcessSelected()">
      <span class="icon-text">
        <span>{{ProcessButtonText}}</span>
        <span class="icon">
          <i class="fa fa-play"></i>
        </span>
      </span>
    </button>
  }
</app-pageheader>

<input
  #dmvUploadInput
  type="file"
  accept=".csv,.txt,text/csv,text/plain"
  style="display:none"
  (change)="OnUploadSelected($event)" />

  <div class="modal" [ngClass]="{'is-active': ShowImportSummaryModal}">
    <div class="modal-background" (click)="CloseImportSummaryModal()"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">DMV Import Summary</p>
        <button class="delete" aria-label="close" (click)="CloseImportSummaryModal()"></button>
      </header>
      <section class="modal-card-body">
        @if (LastImportErrorMessage) {
          <div class="notification is-danger is-light">
            <strong>Import failed</strong>
            @if (LastImportErrorCode) {
              <span>({{LastImportErrorCode}})</span>
            }
            <div class="mt-2">{{LastImportErrorMessage}}</div>
          </div>
        }

        @if (LastImportSummary; as s) {
          <div>
            <div class="content">
              <ul>
                <li><strong>Rows in Uploaded File</strong>: {{ImportRowsProcessed}}</li>
                <li><strong>Rows matched to Processing citations (by plate)</strong>: {{ImportRowsMatched}}</li>
                @if (ImportRowsNotLinked > 0) {
                  <li class="has-text-grey">
                    <strong>Upload rows not linked to Processing citations</strong>: {{ImportRowsNotLinked}}
                  </li>
                }
                <li><strong>Citations updated (awaiting DMV info)</strong>: {{ImportCitationsUpdated}}</li>
                <li><strong>Remaining DMV records in Processing</strong>: {{RemainingProcessingCitations}}</li>
              </ul>
            </div>
            @if (s.Warnings?.length) {
              <div class="notification is-warning is-light">
                <strong>Warnings ({{s.Warnings.length}})</strong>
                <ul class="mt-2">
                  @for (w of s.Warnings; track w) {
                    <li>{{w}}</li>
                  }
                </ul>
              </div>
            }
          </div>
        }
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" (click)="CloseImportSummaryModal()">Close</button>
      </footer>
    </div>
  </div>

  <app-datalistview
    [Columns]="Columns"
    [ShowMap]="false"
    ApiUrl="enforcement/dmv/pending/searches"
    [AllowEdit]="true"
    EditUrl="enforcement/citations/issued/:id"
    [AllowSelectBoxes]="ShowDmvActions"
    [SelectBoxCanShow]="CanSelectRow"
    [SelectedItems]="SelectedItems"
    (SelectBoxChanged)="OnSelectBoxChanged($event)"
    [AllowAllResults]="true">
    <div class="level mb-0">
      <div class="level-left">
        <app-filter-set>
          <div app-search-filter></div>
          <div app-dmv-state-filter></div>
          <div app-search-button></div>
        </app-filter-set>
      </div>
      @if (ShowDmvActions && HasSelectableRows) {
        <div class="level-right">
          <div class="level-item">
            <button
              type="button"
              [disabled]="Processing"
              (click)="ToggleSelectAll()"
              class="button is-rounded"
              [ngClass]="AllItemsSelected ? 'is-danger is-light' : 'is-info is-light'">
              <span class="icon-text">
                <span>{{ AllItemsSelected ? 'Deselect all' : 'Select all missing' }}</span>
                <span class="icon">
                  <i class="fa" [ngClass]="AllItemsSelected ? 'fa-minus-square-o' : 'fa-check-square-o'"></i>
                </span>
              </span>
            </button>
          </div>
        </div>
      }
    </div>
  </app-datalistview>

